import { render, staticRenderFns } from "./PrestationReservationPeriod.vue?vue&type=template&id=1bf4acf6&scoped=true"
import script from "./PrestationReservationPeriod.vue?vue&type=script&lang=js"
export * from "./PrestationReservationPeriod.vue?vue&type=script&lang=js"
import style0 from "./PrestationReservationPeriod.vue?vue&type=style&index=0&id=1bf4acf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf4acf6",
  null
  
)

export default component.exports